// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchFeedbacks } from '../carporateServices/feedbackAndManagementListSlice';

// // Define the form data type
// export interface MaintenanceRequestFormData {
//   id?: string;
//   name?: string;
//   role?: string;
//   phone_number?: string;
//   email_address?: string;
//   date_of_request?: string;
//   location_of_issue?: string;
//   other_location?: string;
//   description_of_issue?: string;
//   urgency_level?: string;
//   date_issue_noticed?: string;
//   issue_reported_before?: string;
//   previous_report_date?: string;
//   preferred_access_time?: string;
//   access_instructions?: string;
//   participant_aware?: string;
//   photo?: File | string;
//   received_by?: string;
//   date_received?: string;
//   action_taken?: string;
//   assigned_to?: string;
//   completion_date?: string;
//   notes?: string;
//   client_email?: string;
//   group_id?: string; // Added to match payload
//   service_name_id?: string; // Added to match payload
// }

// // Define the MaintenanceRequest type to match API response and initialData
// export interface MaintenanceRequest {
//   id?: string;
//   name?: string;
//   role?: string;
//   phone_number?: string;
//   email_address?: string;
//   date_of_request?: string;
//   location_of_issue?: string;
//   other_location?: string;
//   description?: string;
//   urgency_level?: string;
//   date_issue_noticed?: string;
//   issue_reported_before?: string;
//   previous_report_date?: string;
//   preferred_access_time?: string;
//   access_instructions?: string;
//   participant_aware?: string;
//   photo?: string;
//   received_by?: string;
//   date_received?: string;
//   action_taken?: string;
//   assigned_to?: string;
//   completion_date?: string;
//   notes?: string;
//   client_email?: string;
//   created_by?: string;
//   created_at?: string;
// }

// // Define the state type
// export interface MaintenanceRequestState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: MaintenanceRequestState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Async thunk for posting maintenance request data
// export const submitMaintenanceRequest = createAsyncThunk<
//   { message: string },
//   { formData: MaintenanceRequestFormData; initialData?: MaintenanceRequest },
//   { rejectValue: string }
// >('maintenanceRequest/submit', async ({ formData, initialData }, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     // For initial save, include empty Office Use Only fields
//     // For update, merge initialData with formData, prioritizing formData
//     const payload: MaintenanceRequestFormData = {
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       id: formData.id,
//       name: initialData?.name || formData.name || '',
//       role: initialData?.role || formData.role || '',
//       phone_number: initialData?.phone_number || formData.phone_number || '',
//       email_address: initialData?.email_address || formData.email_address || '',
//       date_of_request: initialData?.date_of_request || formData.date_of_request || '',
//       location_of_issue:
//         (initialData?.location_of_issue || formData.location_of_issue) === 'Other'
//           ? initialData?.other_location || formData.other_location || ''
//           : initialData?.location_of_issue || formData.location_of_issue || '',
//       other_location: initialData?.other_location || formData.other_location || '',
//       description_of_issue: initialData?.description || formData.description_of_issue || '',
//       urgency_level: initialData?.urgency_level || formData.urgency_level || '',
//       date_issue_noticed: initialData?.date_issue_noticed || formData.date_issue_noticed || '',
//       issue_reported_before:
//         initialData?.issue_reported_before || formData.issue_reported_before || '',
//       previous_report_date:
//         initialData?.previous_report_date || formData.previous_report_date || '',
//       preferred_access_time:
//         initialData?.preferred_access_time || formData.preferred_access_time || '',
//       access_instructions: initialData?.access_instructions || formData.access_instructions || '',
//       participant_aware: initialData?.participant_aware || formData.participant_aware || '',
//       photo:
//         formData.photo instanceof File
//           ? await convertFileToBase64(formData.photo)
//           : formData.photo || initialData?.photo || '',
//       received_by: initialData?.received_by || formData.received_by || '',
//       date_received: initialData?.date_received || formData.date_received || '',
//       action_taken: initialData?.action_taken || formData.action_taken || '',
//       assigned_to: initialData?.assigned_to || formData.assigned_to || '',
//       completion_date: initialData?.completion_date || formData.completion_date || '',
//       notes: initialData?.notes || formData.notes || ''
//     };

//     const response = await axiosInstance.post('/ndis/form/maintenance-requests', payload, {
//       headers: { 'Content-Type': 'application/json' }
//     });
//     await dispatch(fetchFeedbacks({ client_email })).unwrap();

//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.message || 'Failed to submit maintenance request');
//   }
// });

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// const maintenanceRequestSlice = createSlice({
//   name: 'maintenanceRequest',
//   initialState,
//   reducers: {
//     clearMaintenanceRequestState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitMaintenanceRequest.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitMaintenanceRequest.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Maintenance request submitted successfully';
//         state.error = null;
//       })
//       .addCase(submitMaintenanceRequest.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearMaintenanceRequestState } = maintenanceRequestSlice.actions;
// export default maintenanceRequestSlice.reducer;



import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchFeedbacks } from '../carporateServices/feedbackAndManagementListSlice';

// Define the form data type
export interface MaintenanceRequestFormData {
  id?: string;
  name?: string;
  role?: string;
  phone_number?: string;
  email_address?: string;
  date_of_request?: string;
  location_of_issue?: string;
  other_location?: string;
  description_of_issue?: string;
  urgency_level?: string;
  date_issue_noticed?: string;
  issue_reported_before?: string;
  previous_report_date?: string;
  preferred_access_time?: string;
  access_instructions?: string;
  participant_aware?: string;
  photo?: File | string;
  received_by?: string;
  date_received?: string;
  action_taken?: string;
  assigned_to?: string;
  completion_date?: string;
  notes?: string;
  client_email?: string;
  group_id?: string;
  service_name_id?: string;
  resolved?: string;
}

// Define the MaintenanceRequest type to match API response and initialData
export interface MaintenanceRequest {
  id?: string;
  name?: string;
  role?: string;
  phone_number?: string;
  email_address?: string;
  date_of_request?: string;
  location_of_issue?: string;
  other_location?: string;
  description?: string;
  urgency_level?: string;
  date_issue_noticed?: string;
  issue_reported_before?: string;
  previous_report_date?: string;
  preferred_access_time?: string;
  access_instructions?: string;
  participant_aware?: string;
  photo?: string;
  received_by?: string;
  date_received?: string;
  action_taken?: string;
  assigned_to?: string;
  completion_date?: string;
  notes?: string;
  client_email?: string;
  created_by?: string;
  created_at?: string;
  resolved?: string;
}

// Define the state type
export interface MaintenanceRequestState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: MaintenanceRequestState = {
  loading: false,
  message: null,
  error: null
};

// Async thunk for posting maintenance request data
export const submitMaintenanceRequest = createAsyncThunk<
  { message: string },
  { formData: MaintenanceRequestFormData; initialData?: MaintenanceRequest },
  { rejectValue: string }
>('maintenanceRequest/submit', async ({ formData, initialData }, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    // For initial save, include empty Office Use Only fields
    // For update, merge initialData with formData, prioritizing formData
    const payload: MaintenanceRequestFormData = {
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      id: formData.id,
      name: initialData?.name || formData.name || '',
      role: initialData?.role || formData.role || '',
      phone_number: initialData?.phone_number || formData.phone_number || '',
      email_address: initialData?.email_address || formData.email_address || '',
      date_of_request: initialData?.date_of_request || formData.date_of_request || '',
      location_of_issue:
        (initialData?.location_of_issue || formData.location_of_issue) === 'Other'
          ? initialData?.other_location || formData.other_location || ''
          : initialData?.location_of_issue || formData.location_of_issue || '',
      other_location: initialData?.other_location || formData.other_location || '',
      description_of_issue: initialData?.description || formData.description_of_issue || '',
      urgency_level: initialData?.urgency_level || formData.urgency_level || '',
      date_issue_noticed: initialData?.date_issue_noticed || formData.date_issue_noticed || '',
      issue_reported_before:
        initialData?.issue_reported_before || formData.issue_reported_before || '',
      previous_report_date:
        initialData?.previous_report_date || formData.previous_report_date || '',
      preferred_access_time:
        initialData?.preferred_access_time || formData.preferred_access_time || '',
      access_instructions: initialData?.access_instructions || formData.access_instructions || '',
      participant_aware: initialData?.participant_aware || formData.participant_aware || '',
      photo:
        formData.photo instanceof File
          ? await convertFileToBase64(formData.photo)
          : formData.photo || initialData?.photo || '',
      received_by: initialData?.received_by || formData.received_by || '',
      date_received: initialData?.date_received || formData.date_received || '',
      action_taken: initialData?.action_taken || formData.action_taken || '',
      assigned_to: initialData?.assigned_to || formData.assigned_to || '',
      completion_date: initialData?.completion_date || formData.completion_date || '',
      notes: initialData?.notes || formData.notes || '',
      resolved: initialData?.resolved || formData.resolved || ''
    };

    const response = await axiosInstance.post('/ndis/form/maintenance-requests', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    await dispatch(fetchFeedbacks({ client_email })).unwrap();

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to submit maintenance request');
  }
});

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

const maintenanceRequestSlice = createSlice({
  name: 'maintenanceRequest',
  initialState,
  reducers: {
    clearMaintenanceRequestState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitMaintenanceRequest.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitMaintenanceRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Maintenance request submitted successfully';
        state.error = null;
      })
      .addCase(submitMaintenanceRequest.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearMaintenanceRequestState } = maintenanceRequestSlice.actions;
export default maintenanceRequestSlice.reducer;
